import { render, staticRenderFns } from "./ActiveTravelBanner.vue?vue&type=template&id=5af32e90&scoped=true"
import script from "./ActiveTravelBanner.vue?vue&type=script&lang=js"
export * from "./ActiveTravelBanner.vue?vue&type=script&lang=js"
import style0 from "./ActiveTravelBanner.vue?vue&type=style&index=0&id=5af32e90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af32e90",
  null
  
)

export default component.exports